import { combineReducers, configureStore } from "@reduxjs/toolkit";
import NavBarSlice from "../slices/navbar.slice";
import SideBarSlice from "../slices/sidebar.slice";
import LoginSlice from "../slices/login.slice";
import UserSlice from "../slices/user.slice";
import patientlookupSlice  from "../slices/patientlookup.slice";
import NotesErrorListSlice  from "../slices/noteserror.slice";
import MappingNotesTypeListSlice from "../slices/mappingnotestype.slice";
import CustomNotesTypeListSlice from "../slices/customnotestype.slice"
import RoleListSlice from "../slices/role.slice"
import MappedDataListSlice from "../slices/mapping.slice"
import EfaxListSlice from "../slices/efax.slice"

// Combine all reducers
const reducers = combineReducers({
  SideBar: SideBarSlice,
  NavbarReduce: NavBarSlice,
  login: LoginSlice,
  users:UserSlice,
  patientlookUp:patientlookupSlice,
  NotesErrorList:NotesErrorListSlice,
  MappingNotesTypeList:MappingNotesTypeListSlice,
  CustomNotesTypeList:CustomNotesTypeListSlice,
  RoleList:RoleListSlice,
  MappedDataList: MappedDataListSlice,
  efax: EfaxListSlice,
});

// Configure the store
const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable this if non-serializable data is handled (e.g., Date, Map)
    }),
});

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
